import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import {useConfig} from './useConfig';

 function useGraphQL() {
    const { graphQLApiHost } = useConfig();

    const httpLink = new HttpLink({
        uri: graphQLApiHost,
        headers: {
            'Content-Type': 'application/json',
        }
    });

    const showDevTools = graphQLApiHost.includes('localhost');
    return new ApolloClient({
      cache: new InMemoryCache(),
      link: httpLink,
      connectToDevTools: showDevTools
    });
 }

export default useGraphQL;
